export default __webpack_public_path__ + "static/media/antelope-5-thumbnail.0d3c01e1.webp";